import { render, staticRenderFns } from "./SkillList.vue?vue&type=template&id=25b1b738&scoped=true&"
import script from "./SkillList.vue?vue&type=script&lang=js&"
export * from "./SkillList.vue?vue&type=script&lang=js&"
import style0 from "./SkillList.vue?vue&type=style&index=0&id=25b1b738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1b738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b1b738')) {
      api.createRecord('25b1b738', component.options)
    } else {
      api.reload('25b1b738', component.options)
    }
    module.hot.accept("./SkillList.vue?vue&type=template&id=25b1b738&scoped=true&", function () {
      api.rerender('25b1b738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/SkillList.vue"
export default component.exports